export interface ClozeSegment {
  kind: 'text' | 'blank';
  /** Chuỗi để render. Với 'blank' là ô chuẩn hoá (BLANK_PLACEHOLDER), KHÔNG phải ký hiệu gốc. */
  text: string;
  /** Chỉ có ở 'blank': ký hiệu gốc trong prompt — giữ để debug/test, không render. */
  raw?: string;
}

/** Ô trống chuẩn hoá: 3 ký tự U+3000 (ideographic space) — nền highlight tạo thành hình ô. */
export const BLANK_PLACEHOLDER = '　　　';

/// Bám đúng SIG_BLANK ở packages/database/prisma/seed/parsers/exercises.ts — cùng tập ký hiệu
/// mà parser dùng để phân loại CLOZE.
const BLANK_RE = /[（(][ \t　＿_]*[）)]|[＿_]{3,}/g;

/** Chẻ prompt CLOZE thành các đoạn text/blank xen kẽ để render highlight, KHÔNG suy ra đáp án. */
export function splitClozeSegments(prompt: string): ClozeSegment[] {
  if (!prompt.trim()) return [];

  const segments: ClozeSegment[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  BLANK_RE.lastIndex = 0;
  while ((match = BLANK_RE.exec(prompt)) !== null) {
    const textPart = prompt.slice(lastIndex, match.index);
    if (textPart) segments.push({ kind: 'text', text: textPart });
    segments.push({ kind: 'blank', text: BLANK_PLACEHOLDER, raw: match[0] });
    lastIndex = match.index + match[0].length;
  }
  const rest = prompt.slice(lastIndex);
  if (rest) segments.push({ kind: 'text', text: rest });

  return segments;
}
